// client/src/features/salesCoach/api/salesCoachApi.js
import axiosInstanceNode from "@/api/axiosInstanceNode";

export const salesCoachApi = {
  // Trainings CRUD
  listTrainings: async () => {
    const response = await axiosInstanceNode.get("/sales-coach/trainings");
    return response.data?.data || [];
  },

  getTraining: async (id) => {
    const response = await axiosInstanceNode.get(`/sales-coach/trainings/${id}`);
    return response.data?.data || null;
  },

  createTraining: async (data) => {
    const response = await axiosInstanceNode.post("/sales-coach/trainings", data);
    return response.data?.data;
  },

  updateTraining: async (id, data) => {
    const response = await axiosInstanceNode.put(`/sales-coach/trainings/${id}`, data);
    return response.data?.data;
  },

  deleteTraining: async (id) => {
    const response = await axiosInstanceNode.delete(`/sales-coach/trainings/${id}`);
    return response.data;
  },

  // Trainer session
  startTrainerSession: async (trainingId) => {
    const response = await axiosInstanceNode.post("/sales-coach/trainer-sessions", { trainingId });
    return response.data;
  },

  sendTrainerMessage: async (sessionId, content, isVoice = false) => {
    const response = await axiosInstanceNode.post(`/sales-coach/trainer-sessions/${sessionId}/message`, {
      content,
      isVoice
    });
    return response.data?.data;
  },

  endTrainerSession: async (sessionId) => {
    const response = await axiosInstanceNode.post(`/sales-coach/trainer-sessions/${sessionId}/end`);
    return response.data;
  },

  // Rules
  fetchRules: async (trainingId) => {
    const response = await axiosInstanceNode.get(`/sales-coach/trainings/${trainingId}/rules`);
    return response.data?.data || [];
  },

  createRule: async (trainingId, ruleText) => {
    const response = await axiosInstanceNode.post(`/sales-coach/trainings/${trainingId}/rules`, { ruleText });
    return response.data?.data;
  },

  updateRule: async (ruleId, data) => {
    const response = await axiosInstanceNode.put(`/sales-coach/rules/${ruleId}`, data);
    return response.data?.data;
  },

  deleteRule: async (ruleId) => {
    const response = await axiosInstanceNode.delete(`/sales-coach/rules/${ruleId}`);
    return response.data;
  },

  // Personas
  listPersonas: async () => {
    const response = await axiosInstanceNode.get("/sales-coach/personas");
    return response.data?.data || [];
  },

  // User learning session
  createUserSession: async (data) => {
    const response = await axiosInstanceNode.post("/sales-coach/user-sessions", data);
    return response.data;
  },

  sendUserMessage: async (sessionId, content, isVoice = false) => {
    const response = await axiosInstanceNode.post(`/sales-coach/user-sessions/${sessionId}/message`, {
      content,
      isVoice
    });
    return response.data?.data;
  },

  finishUserSession: async (sessionId) => {
    const response = await axiosInstanceNode.post(`/sales-coach/user-sessions/${sessionId}/finish`);
    return response.data?.data;
  },

  endUserSession: async (sessionId) => {
    const response = await axiosInstanceNode.post(`/sales-coach/user-sessions/${sessionId}/end`);
    return response.data?.data;
  },

  fetchAssessment: async (sessionId) => {
    const response = await axiosInstanceNode.get(`/sales-coach/user-sessions/${sessionId}/assessment`);
    return response.data?.data;
  },

  // Dashboards
  fetchPerformance: async () => {
    const response = await axiosInstanceNode.get("/sales-coach/performance");
    return response.data?.data || [];
  },

  fetchRepHistory: async () => {
    const response = await axiosInstanceNode.get("/sales-coach/rep/history");
    return response.data?.data || [];
  },
};
